import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { BaseInputDirective } from '../base-input.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatLabel, MatFormField, MatHint, MatError, MatPrefix } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-currency-input',
  templateUrl: './currency-input.component.html',
  styleUrls: ['./currency-input.component.css'],
  imports:[ReactiveFormsModule, MatAutocompleteModule, CurrencyPipe, CommonModule, MatLabel, MatFormField, MatIconModule, MatInput,
    MatHint, MatError, MatPrefix,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],   
})
export class CurrencyInputComponent extends BaseInputDirective implements OnInit {
  valueFormatted: string;

  
 


  ngOnInit() {
    super.ngOnInit();
  }

  onInputKeyDown(event) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  formatCurrency(x) {
    const z = Number(x.formControl.value).toFixed(2);
    this.valueFormatted = z;
    x.formControl.value = z;
  }
}
